// extracted by mini-css-extract-plugin
export default {"ClickDrag":"ClickDrag_ClickDrag__FTGkl"};